module.exports = __webpack_public_path__ + "img/18.990d6218.jpg";